import { createSlice } from "@reduxjs/toolkit";
import { sendContactFormBuilder } from "./builder";

const initialState = {
  loading: false,
  success: false,
  message: null,
  error: null,
};

export const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    clearContactState: (state) => {
      state.loading = false;
      state.success = false;
      state.message = null;
      state.error = null;
    },
    resetContactError: (state) => {
      state.error = null;
    },
    resetContactSuccess: (state) => {
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    sendContactFormBuilder(builder);
  },
});

export const { clearContactState, resetContactError, resetContactSuccess } = contactSlice.actions;

// Selectors
export const selectContactLoading = (state) => state.contact.loading;
export const selectContactSuccess = (state) => state.contact.success;
export const selectContactMessage = (state) => state.contact.message;
export const selectContactError = (state) => state.contact.error;

export default contactSlice.reducer;